export default {
  methods: {
    updateModelGeometry({ componentName, applyingRecipe, swatchObj }) {
      let promises = [];
      if(!swatchObj || !swatchObj.geometry_updates) return Promise.resolve();
      swatchObj.geometry_updates.forEach(geometryUpdate => {
        if (this.validateGeometryUpdate({geometryUpdate, componentName, applyingRecipe})) {
          promises.push(this.swapGeometries({ geometryUpdate, updateType: "swatches" }).then(()=>{
            this.updateRecipeWithMerchandisingSwatchRules({swatch: swatchObj, componentName})
          })
          .catch(e => console.error('swapGeometries: ', e)))
        }
      });

      return Promise.all(promises).then(() => {
        return Promise.resolve();
      })
    }
  }
};
